@if (
  (type === 'Point' && dataLayerTypeStore.pointLayers()) ||
    (type === 'Polygon' && dataLayerTypeStore.polygonLayers());
  as types
) {
  @if (types.length > 0) {
    <p-pickList
      #listPickerCtrl
      [source]="items"
      [target]="selected"
      [sourceHeader]="type === 'Point' ? 'Standorte' : 'Räume'"
      targetHeader="Auswahl"
      [dragdrop]="true"
      [responsive]="true"
      [showSourceControls]="showSourceControls"
      [showTargetControls]="showTargetControls"
      (onMoveToSource)="updateSelection()"
      (onMoveToTarget)="updateSelection()"
      (onMoveAllToSource)="updateSelection()"
      (onMoveAllToTarget)="updateSelection()"
      [sourceStyle]="{ height: '30rem' }"
      [targetStyle]="{ height: '30rem' }"
      breakpoint="1400px">
      <ng-template let-item pTemplate="item">
        <div class="flex-1 flex flex-column gap-2">
          <div class="flex align-items-center gap-2 text-lg">
            @if (type === 'Point') {
              <app-svg-icon [key]="item.icon" />
            } @else {
              <i [class]="item.icon"></i>
            }
            <span>
              {{ item.label }}
            </span>
          </div>
        </div>
      </ng-template>
    </p-pickList>
  } @else {
    <app-alert styleClass="m-0 p-3" [canToggle]="false" severity="secondary">
      @if (type === 'Point') {
        Keine Standorte gefunden
      } @else {
        Keine Räume gefunden
      }
    </app-alert>
  }
}
